<script>
import { mapGetters } from 'vuex'
import TeamResource from '@/resources/team'

export default {
    name: 'AccountLapTimes',
    computed: {
        ...mapGetters(['userId']),
    },
    data() {
        return {
            hasTeams: false,
        }
    },
    async mounted() {
        const teams = await TeamResource.filterAll({ members: this.userId })
        this.hasTeams = teams.length > 0
    },
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Lap Times</h4>
            <p class="text-muted mb-0">Review your race performance and compare with others.</p>
        </div>
        <b-row>
            <b-col md="6" class="mb-3">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="stopwatch-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">MyLaps</h6>
                            <p class="text-muted small mb-3">View your personal lap times and session history.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'laps' }">Go to MyLaps</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="bar-chart-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Leaderboards</h6>
                            <p class="text-muted small mb-3">See how you rank against other racers on every track.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'leaderboards' }">Go to Leaderboards</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col md="6" class="mb-3" v-if="hasTeams">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="people-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Teams</h6>
                            <p class="text-muted small mb-3">Manage the teams you're racing with in points series.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'accountTeams' }">Go to Teams</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
